import {combineReducers} from 'redux';

import {toasterReducers} from '@homeaway/react-toaster';
import {tripboardButtonReducer} from '@homeaway/react-trip-board-button';

import config from './config';
import search from './search';
import greatPlaces from './greatPlaces';
import content from './content';
import destination from './destination';
import i18n from './i18n';
import seoLinkpile from './seo-linkpile';
import abacus from './abacus';
import siteContext from './siteContext';
import error from './error';
import modules from './modules';
import familyFriendly from './family-friendly';

export const reducers = combineReducers({
    config,
    search,
    greatPlaces,
    content,
    destination,
    i18n,
    seoLinkpile,
    abacus,
    siteContext,
    error,
    modules,
    familyFriendly,
    tripboardButton: tripboardButtonReducer,
    toaster: toasterReducers
});

export default reducers;
